import React, { useState, useEffect } from "react";
import "./Profile.css";
import { useLocation, useParams } from "react-router-dom";
import imgHeader from "../../assets/image/img-header.png";
import imgHistory from "../../assets/image/img-history.png";
import { Anggota, Header, Banner, Good } from "../../components/joinComponents";
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";

const Profile = () => {
  const header = {
    title: "Profile",
    description: "Kampung Mundu",
    img: imgHeader,
  };

  const banners = {
    description: "Setiap Halaman Meretas Perjalanan dan Aspirasi",
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
    });
  }, []);

  const [showAllText, setShowAllText] = useState(false);

  const toggleTextDisplay = () => {
    setShowAllText(!showAllText);
  };

  const buttonText = showAllText
    ? "Tampilkan Lebih Sedikit"
    : "Tampilkan Lebih Banyak";

  return (
    <>
      <Helmet>
        <title>Profile: Kampung digital dan teknologi berbasis website</title>
        <meta
          name='keyword'
          content='mundu, mundu 1902, moendoe, moendoe 1902, kampung digital, website desa, web keren, lubang buaya, jakarta timur, kampung keren'
        />
        <meta
          name='description'
          content='Mundu adalah sebuah nama daerah yang teletak di Jakarta Timur, Saat ini kami mengedepankan perubahan berbasis teknologi, untuk menjadikan kampung yang terdepan dalam setiap aspek kegiatan.'
        />
        <meta
          name='og:title'
          content='profile: Kampung digital dan teknologi berbasis website'
        />
        <meta
          name='og:description'
          content='Mundu adalah sebuah nama daerah yang teletak di Jakarta Timur, Saat ini kami mengedepankan perubahan berbasis teknologi, untuk menjadikan kampung yang terdepan dalam setiap aspek kegiatan.'
        />
      </Helmet>

      <Header data={header} />

      <div className='container-profile w-full flex flex-col justify-evenly lg:px-10 sm:px-5'>
        <div className='box-history flex flex-col lg:mt-16 sm:mt-5'>
          <p className='title-history w-fit lg:ml-16 sm:ml-5 md:ml-16 p-3 lg:text-7xl md:text-5xl'>
            sejarah singkat
          </p>
          <p className='title-history w-fit p-3 lg:text-7xl md:text-5xl'>
            Kampung Mundu
          </p>
        </div>

        <div className='box-article-profile flex items-center justify-between w-full lg:flex-row md:flex-row sm:flex-col md:gap-5'>
          <article className='flex w-full lg:flex-row md:flex-row sm:flex-col-reverse mt-10 lg:gap-5 sm:gap-4 sm:mt-5 items-start'>
            <div className='colContentParagh flex flex-col w-full justify-beetwen lg:gap-5'>
              <p
                className={`descProfile lg:max-w-screen-md ${
                  showAllText ? "show-all-text" : ""
                }`}
              >
                Kampung Mundu adalah sebuah nama daerah yang terletak di Jakarta
                Timur. Awal mula nama Mundu sendiri diberikan karena ada sebuah
                pohon Mundu yang begitu besar yang berada di area sekitar, oleh
                karena itu dibuat lah nama Mundu, untuk tanggal dan tahunnya
                kurang begitu spesifik, tapi nama Mundu sendiri sangat erat
                kaitannya dengan angka 1902. Ada yang bilang ini adalah sebuah
                tahun dimana kampung ini berdiri,
              </p>
              <p
                className={`descProfile lg:max-w-screen-md ${
                  showAllText ? "show-all-text" : ""
                }`}
              >
                Cerita tentang asal-usul Kampung Mundu di Jakarta Timur ini
                memang menarik. Nama Mundu yang berkaitan dengan pohon besar dan
                tahun 1902 memberikan aura sejarah yang kuat. Kampung-kampung
                dengan cerita unik seperti ini mengingatkan kita akan akar
                sejarah yang kaya dan pentingnya menjaga warisan budaya lokal.
                Semoga cerita ini terus dikenang dan dirawat oleh masyarakat
                setempat.
              </p>
              <button
                className={`btnTampil w-fit ${
                  showAllText ? "activeBtnTampil" : ""
                }`}
                onClick={toggleTextDisplay}
              >
                {buttonText}
              </button>
            </div>
            <img
              src={imgHistory}
              alt=''
              srcSet=''
              className='img-profile-title'
            />
          </article>
        </div>
        <div className='conProf mt-10' id='conProf'>
          {/* <SliderText /> */}

          <Anggota />
        </div>
      </div>
      <Banner data={banners} />
      <Good />
    </>
  );
};

export default Profile;
